import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import {
  ReserveTypesQueryQuery,
  ReserveTypesQueryQueryVariables,
} from '../gql/graphql';

export const ReserveTypesQuery = gql`
  query reserveTypesQuery($reserveTypeFilterInput: ReserveTypeFilterInput) {
    reserveTypes(filters: $reserveTypeFilterInput) {
      pageInfo {
        totalResults
      }
      edges {
        node {
          uuid
          name
        }
      }
    }
  }
`;

export function useReserveTypesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ReserveTypesQueryQuery,
    ReserveTypesQueryQueryVariables
  >
) {
  const options = { ...baseOptions };
  return Apollo.useQuery<
    ReserveTypesQueryQuery,
    ReserveTypesQueryQueryVariables
  >(ReserveTypesQuery, options);
}
export function useReserveTypesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ReserveTypesQueryQuery,
    ReserveTypesQueryQueryVariables
  >
) {
  const options = { ...baseOptions };
  return Apollo.useLazyQuery<
    ReserveTypesQueryQuery,
    ReserveTypesQueryQueryVariables
  >(ReserveTypesQuery, options);
}
export type ReserveTypesQueryHookResult = ReturnType<
  typeof useReserveTypesQuery
>;
export type ReserveTypesLazyQueryHookResult = ReturnType<
  typeof useReserveTypesLazyQuery
>;
